export default "__VITE_ASSET__BvTg3wRU__"